/* MWT — theme.js (vanilla, sans dépendance) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var M = window.MWT || {};
  var ROOT = (M.root || '/').replace(/\/?$/, '/'); /* '/en' -> '/en/' (routes.root_url n'a pas de / final hors langue principale) */
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input, select');
    if (f) f.focus();
  }
  function closeDrawers() {
    $$('[data-drawer]').forEach(function (d) { d.hidden = true; });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closePopup(); }
  });

  /* ---------- Cart ---------- */
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.toggleAttribute('data-zero', !count); });
  }
  function refreshDrawer(open) {
    return fetch(ROOT + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = html.querySelector('#CartDrawer');
      var cur = $('#CartDrawer');
      if (fresh && cur) { fresh.hidden = !open && cur.hidden; cur.replaceWith(fresh); }
      return fetch(M.cartUrl + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCounts(cart.item_count);
      if (open) openDrawer('cart');
    });
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(M.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) { alert((err && err.description) || 'Ce produit ne peut pas être ajouté.'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(key, qty) {
    var wrap = $('#CartDrawer');
    if (wrap) wrap.classList.add('is-loading');
    return fetch(M.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      return refreshDrawer(true);
    });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) { e.preventDefault(); addToCart(add.getAttribute('data-add'), 1, add); closeQuick(add); return; }
    var ch = e.target.closest('[data-change]');
    if (ch) { e.preventDefault(); changeLine(ch.getAttribute('data-change'), Number(ch.getAttribute('data-qty'))); return; }
    var qo = e.target.closest('[data-quick-open]');
    if (qo) { var q = qo.closest('[data-quick]'); qo.hidden = true; q.querySelector('.quick__panel').hidden = false; return; }
    var qc = e.target.closest('[data-quick-close]');
    if (qc) closeQuick(qc);
  });
  function closeQuick(el) {
    var q = el.closest('[data-quick]'); if (!q) return;
    var p = q.querySelector('.quick__panel'), o = q.querySelector('[data-quick-open]');
    if (p) p.hidden = true; if (o) o.hidden = false;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-product-form]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value;
    var qty = Number((f.querySelector('[name="quantity"]') || {}).value || 1);
    addToCart(id, qty, f.querySelector('[type="submit"]'));
  });
  $$('[data-qty-input]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); if (!b) return;
      input.value = Math.max(1, Number(input.value || 1) + Number(b.getAttribute('data-step')));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var preJson = root.querySelector('[data-preorder-json]');
    var pre = preJson ? JSON.parse(preJson.textContent) : null; /* v1.0.29 précommande */
    var preProp = root.querySelector('[data-preorder-prop]'), preNote = root.querySelector('[data-preorder-note]');
    function isPreorder(v) { return !!(pre && v.available && v.inventory_management && pre.stock[String(v.id)] <= 0); }
    var idInput = root.querySelector('form[data-product-form] [name="id"]');
    var btn = root.querySelector('[data-buy-btn]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var qtyInput = root.querySelector('[name="quantity"]');
    var selLabels = $$('[data-selected-label]', root);
    function current() {
      return $$('fieldset[data-option]', root).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function update() {
      var sel = current();
      selLabels.forEach(function (l, i) { l.textContent = sel[i] || 'à choisir'; });
      if (sel.indexOf(null) > -1) { btn.disabled = false; btn.setAttribute('data-needs-option', ''); return; }
      btn.removeAttribute('data-needs-option');
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) { btn.disabled = true; btn.textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      var q = Number((qtyInput && qtyInput.value) || 1);
      priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      btn.disabled = !v.available;
      var isPre = isPreorder(v);
      btn.textContent = isPre ? pre.label + ' — ' + money(v.price * q) : (v.available ? 'Ajouter au panier — ' + money(v.price * q) : 'Épuisé');
      if (preProp) preProp.disabled = !isPre;
      if (preNote) preNote.hidden = !isPre;
      restockToggle(root, product, v);
      root.setAttribute('data-price-cents', v.price * q);
      updateInstall(root);
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      // disponibilité des tailles
      $$('fieldset[data-option]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[idx] = inp.value;
          var ok = product.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
          inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    root.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option]') || e.target === qtyInput) update(); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-buy-btn]') && btn.hasAttribute('data-needs-option')) {
        e.preventDefault();
        var err = root.querySelector('[data-option-error]'); if (err) err.hidden = false;
      }
    });
    update();
  });

  /* ---------- Alerte retour en stock (sans app) ---------- */
  function restockToggle(root, product, v) {
    var box = root.querySelector('[data-restock]'); if (!box) return;
    var done = box.querySelector('[data-restock-done]');
    if (done && !done.hidden) return; /* confirmation affichée : on la laisse */
    box.hidden = !!v.available;
    if (v.available) return;
    var title = product.has_only_default_variant ? '' : v.title;
    var tags = box.querySelector('[data-restock-tags]');
    if (tags) tags.value = 'restock,restock:' + product.handle + ':' + v.id + (title ? ':' + title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '');
    var lab = box.querySelector('[data-restock-variant]'); if (lab) lab.textContent = title ? (title.indexOf('(') > -1 ? title : '(' + title + ')') : '';
  }
  (function () {
    var box = $('[data-restock]'); if (!box) return;
    var q = new URLSearchParams(location.search);
    if (q.get('restock') === 'ok') {
      var done = box.querySelector('[data-restock-done]'), form = box.querySelector('form');
      if (done) done.hidden = false; if (form) form.hidden = true; box.hidden = false;
      var nm = box.querySelector('[data-restock-name]'), t = $('[data-product] h1'); if (nm && t) nm.textContent = t.textContent.trim();
      q.delete('restock'); history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : ''));
    } else if (q.get('notify') === '1') {
      setTimeout(function () { if (!box.hidden) box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
    }
  })();

  /* ---------- Galerie produit (vignettes + glissement) ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]'); if (!track) return;
    var items = $$('[data-gallery-item]', track), thumbs = $$('[data-gallery-thumb]', g), dots = $$('.gal__dots i', g);
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = Number(t.getAttribute('data-gallery-thumb'));
        track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(i);
      });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; var i = Math.round(track.scrollLeft / track.clientWidth); mark(Math.max(0, Math.min(items.length - 1, i))); });
    }, { passive: true });
  });

  /* ---------- Description : « Voir plus » si elle est longue ---------- */
  $$('[data-desc]').forEach(function (d) {
    var body = d.querySelector('[data-desc-body]'), btn = d.querySelector('[data-desc-toggle]'); if (!body || !btn) return;
    var lh = parseFloat(getComputedStyle(body).lineHeight) || 22;
    if (body.scrollHeight > lh * 7.5) {
      d.classList.add('is-clamped'); btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('is-clamped') === false;
        btn.textContent = open ? 'Voir moins' : 'Voir plus'; btn.setAttribute('aria-expanded', open);
      });
    }
  });

  /* ---------- Paiement fractionné ---------- */
  function updateInstall(root) {
    var box = root.querySelector('[data-install]'); if (!box) return;
    var n = Number(box.getAttribute('data-n') || M.installments || 3);
    var cents = Number(root.getAttribute('data-price-cents') || box.getAttribute('data-cents'));
    box.querySelector('[data-install-label]').textContent = n + ' × ' + money(Math.ceil(cents / n));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-install-n]'); if (!b) return;
    var box = b.closest('[data-install]');
    box.setAttribute('data-n', b.getAttribute('data-install-n'));
    $$('[data-install-n]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
    updateInstall(b.closest('[data-product]') || document.body);
  });

  /* ---------- Modales (guide des tailles) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) { var m = document.getElementById(o.getAttribute('data-modal-open')); if (m && m.showModal) m.showModal(); }
    var c = e.target.closest('[data-modal-close]');
    if (c) c.closest('dialog').close();
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Favoris ---------- */
  var WL = 'mwt-wishlist';
  var wlGet = function () { try { return JSON.parse(localStorage.getItem(WL) || '[]'); } catch (e) { return []; } };
  var wlSet = function (l) { localStorage.setItem(WL, JSON.stringify(l)); wlPaint(); };
  function wlPaint() {
    var l = wlGet();
    $$('[data-wishlist]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-wishlist')) > -1;
      b.setAttribute('aria-pressed', on);
      b.classList.toggle('is-active', on);
    });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = l.length; el.toggleAttribute('data-zero', !l.length); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wishlist'), l = wlGet(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    wlSet(l);
    var page = $('[data-wishlist-page]'); if (page && i > -1) renderWishlist(page);
  });
  window.addEventListener('storage', function (e) { if (e.key === WL) wlPaint(); });
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function renderWishlist(page) {
    var list = wlGet(), grid = page.querySelector('[data-wishlist-grid]'), empty = page.querySelector('[data-wishlist-empty]');
    var countEl = page.querySelector('[data-wishlist-total]');
    if (countEl) countEl.textContent = list.length + ' article' + (list.length > 1 ? 's' : '');
    empty.hidden = list.length > 0; grid.innerHTML = '';
    Promise.all(list.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      grid.innerHTML = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
        return '<li class="card"><div class="card__media"><a href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img class="card__img" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="933">' : '') +
          '</a><button class="fav is-active" type="button" data-wishlist="' + p.handle + '" aria-pressed="true" aria-label="Retirer des favoris"><svg class="icon icon-heart" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.8" aria-hidden="true"><path d="M12 20.5s-7.3-4.5-9.2-9C1.4 8 3.5 4.5 7.1 4.5c2 0 3.5 1 4.9 2.8 1.4-1.8 2.9-2.8 4.9-2.8 3.6 0 5.7 3.5 4.3 7-1.9 4.5-9.2 9-9.2 9z"/></svg></button></div>' +
          '<div class="card__info"><h2 class="card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h2><span class="card__price">' + money(p.price) + '</span></div>' +
          '<a class="btn btn--ghost" href="' + p.url + '">Choisir ma taille</a></li>';
      }).join('');
    });
  }
  var wlPage = $('[data-wishlist-page]');
  if (wlPage) {
    renderWishlist(wlPage);
    var clr = wlPage.querySelector('[data-wishlist-clear]');
    if (clr) clr.addEventListener('click', function () { wlSet([]); renderWishlist(wlPage); });
  }
  wlPaint();

  /* ---------- Newsletter popup ---------- */
  var popup = $('[data-popup]'), teaser = $('[data-teaser]');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    if (localStorage.getItem('mwt-nl') !== 'subscribed') { localStorage.setItem('mwt-nl', 'closed'); if (teaser) teaser.hidden = false; }
  }
  var CONSENT_MAX_AGE = 1000 * 60 * 60 * 24 * 182; /* choix cookies redemandé après 6 mois (recommandation CNIL) */
  function consentValid() {
    try { var c = JSON.parse(localStorage.getItem('mwt-cookies') || 'null'); return !!(c && c.date && Date.now() - c.date <= CONSENT_MAX_AGE); } catch (e) { return false; }
  }
  var nlTimer = null;
  window.MWTStartPopup = function () {
    if (!popup || nlTimer || localStorage.getItem('mwt-nl')) return;
    nlTimer = setTimeout(function () { if (!localStorage.getItem('mwt-nl')) popup.hidden = false; }, Number(popup.getAttribute('data-delay') || 5) * 1000);
  };
  if (popup) {
    if (popup.hasAttribute('data-success')) { popup.hidden = false; localStorage.setItem('mwt-nl', 'subscribed'); }
    else if (!$('[data-cookie]') || consentValid()) window.MWTStartPopup();
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) closePopup(); });
    if (teaser) teaser.addEventListener('click', function () { teaser.hidden = true; popup.hidden = false; });
    $$('[data-copy]', popup).forEach(function (b) {
      b.addEventListener('click', function () { try { navigator.clipboard.writeText(b.getAttribute('data-copy')); } catch (e) {} var s = popup.querySelector('[data-copy-msg]'); if (s) s.textContent = 'Code copié'; });
    });
  }

  /* ---------- Header transparent ---------- */
  var hdr = $('[data-header].header--overlay');
  if (hdr) {
    var solid = function () { hdr.classList.toggle('is-solid', window.scrollY > 24); };
    window.addEventListener('scroll', solid, { passive: true }); solid();
  }

  /* ---------- Newsletter pied de page ---------- */
  if ($('[data-news-success]')) { localStorage.setItem('mwt-nl', 'subscribed'); if (teaser) teaser.hidden = true; }

  /* ---------- Cookies (RGPD) + API Customer Privacy Shopify ---------- */
  var ck = $('[data-cookie]');
  if (ck) {
    var applyConsent = function (c) {
      var send = function () {
        if (window.Shopify && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, function () {});
      };
      if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], send); else send();
    };
    var saveConsent = function (c) {
      localStorage.setItem('mwt-cookies', JSON.stringify({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, date: Date.now() }));
      applyConsent(c); ck.hidden = true; if (window.MWTStartPopup) window.MWTStartPopup();
    };
    if (!consentValid()) { try { localStorage.removeItem('mwt-cookies'); } catch (e) {} ck.hidden = false; }
    var opts = ck.querySelector('[data-cookie-opts]'), more = ck.querySelector('[data-cookie-custom]'), acc = ck.querySelector('[data-cookie-accept]');
    more.addEventListener('click', function () {
      opts.hidden = !opts.hidden; more.setAttribute('aria-expanded', !opts.hidden);
      more.textContent = opts.hidden ? 'Personnaliser' : 'Masquer les options';
      acc.textContent = opts.hidden ? 'Accepter' : 'Enregistrer';
    });
    acc.addEventListener('click', function () {
      if (opts.hidden) return saveConsent({ analytics: true, marketing: true, preferences: true });
      var v = function (k) { return ck.querySelector('[data-consent="' + k + '"]').checked; };
      saveConsent({ analytics: v('analytics'), marketing: v('marketing'), preferences: v('preferences') });
    });
    ck.querySelector('[data-cookie-refuse]').addEventListener('click', function () { saveConsent({ analytics: false, marketing: false, preferences: false }); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-cookie-open]')) {
        e.preventDefault();
        var cur = null; try { cur = JSON.parse(localStorage.getItem('mwt-cookies') || 'null'); } catch (err) {}
        if (cur) ['analytics', 'marketing', 'preferences'].forEach(function (k) { var i = ck.querySelector('[data-consent="' + k + '"]'); if (i) i.checked = !!cur[k]; });
        ck.hidden = false;
      } });
  }

  /* ---------- Haut de page ---------- */
  var top = $('[data-to-top]');
  if (top) {
    window.addEventListener('scroll', function () { top.hidden = window.scrollY < 600; }, { passive: true });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Article : sommaire + progression ---------- */
  var body = $('[data-article-body]'), toc = $('[data-toc]');
  if (body) {
    var hs = $$('h2', body);
    if (toc && hs.length > 1) {
      var ol = toc.querySelector('ol');
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').slice(0, 40);
        var li = document.createElement('li'); li.innerHTML = '<a href="#' + h.id + '">' + esc(h.textContent) + '</a>'; ol.appendChild(li);
      });
      toc.hidden = false;
    }
    var bar = $('[data-progress]');
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.width = (max > 0 ? Math.min(100, scrollY / max * 100) : 0) + '%';
      if (toc) {
        var act = null; hs.forEach(function (h) { if (h.getBoundingClientRect().top < 200) act = h.id; });
        $$('a', toc).forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + act); });
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy-link]'); if (!c) return;
    try { navigator.clipboard.writeText(location.href); c.textContent = 'Lien copié'; } catch (err) {}
  });

  /* ---------- Recommandations produits ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recommendations]');
      if (d && d.innerHTML.trim()) { el.innerHTML = d.innerHTML; wlPaint(); } else { el.closest('section').hidden = true; }
    });
  });

  /* ---------- Collection : tri, filtres, charger plus ---------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]'); if (!more) return;
    e.preventDefault(); more.classList.add('is-loading');
    fetch(more.href).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var grid = $('[data-product-grid]');
      $$('[data-product-grid] > li', doc).forEach(function (li) { grid.appendChild(li); });
      var nextPag = doc.querySelector('[data-pagination]'), curPag = $('[data-pagination]');
      if (nextPag && curPag) curPag.replaceWith(nextPag); else if (curPag) curPag.remove();
      history.replaceState(null, '', more.href);
      wlPaint();
    });
  });
  $$('[data-seo-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.getElementById(b.getAttribute('aria-controls'));
      var open = t.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); b.textContent = open ? 'Réduire' : 'Lire la suite';
    });
  });

  /* ---------- Galerie clientes ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var items = $$('[data-cat]', g), limit = Number(g.getAttribute('data-limit') || 8), cat = 'all', expanded = false;
    var more = g.querySelector('[data-gallery-more]');
    function paint() {
      var shown = 0, total = 0;
      items.forEach(function (it) {
        var match = cat === 'all' || it.getAttribute('data-cat') === cat;
        if (match) total++;
        var vis = match && (expanded || shown < limit);
        if (vis) shown++;
        it.hidden = !vis;
      });
      if (more) { more.hidden = total <= limit; more.textContent = expanded ? 'Voir moins' : 'Voir plus de photos'; }
    }
    g.addEventListener('click', function (e) {
      var c = e.target.closest('[data-filter]');
      if (c) { cat = c.getAttribute('data-filter'); $$('[data-filter]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === c); }); paint(); }
      if (e.target.closest('[data-gallery-more]')) { expanded = !expanded; paint(); }
    });
    paint();
  });
})();
